import React from "react";
import { PROGRESS_STEPS, CITIZEN_STATUS } from "@/lib/citizen";
import { Check } from "lucide-react";

export default function StatusProgressLadder({ status, className = "" }) {
  const current = CITIZEN_STATUS[status]?.step || 1;
  return (
    <div className={`w-full ${className}`} data-testid="progress-ladder">
      <div className="flex items-center">
        {PROGRESS_STEPS.map((s, i) => {
          const stepNo = i + 1;
          const done = stepNo < current;
          const active = stepNo === current;
          return (
            <React.Fragment key={s.key}>
              <div className="flex flex-col items-center flex-shrink-0">
                <div
                  className={`w-9 h-9 flex items-center justify-center rounded-full border-2 text-sm font-semibold transition-all ${
                    done
                      ? "bg-emerald-600 border-emerald-600 text-white"
                      : active
                      ? "bg-blue-700 border-blue-700 text-white pulse-ring"
                      : "bg-white border-zinc-300 text-zinc-400"
                  }`}
                >
                  {done ? <Check className="w-4 h-4 stroke-[2.5]" /> : stepNo}
                </div>
                <div className={`mt-2 text-[10px] uppercase tracking-wider font-semibold ${
                  done || active ? "text-zinc-900" : "text-zinc-400"
                }`}>
                  {s.label}
                </div>
              </div>
              {i < PROGRESS_STEPS.length - 1 && (
                <div className={`flex-1 h-0.5 mx-1 mb-5 transition-all ${
                  stepNo < current ? "bg-emerald-600" : "bg-zinc-200"
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
